import { queryOptions } from "@tanstack/react-query";

import type { QRProjectListResponse, QRProjectOption } from "@/lib/qr-codes/types";

export const qrProjectOptionsQueryOptions = queryOptions({
  queryKey: ["projects", "options"],
  queryFn: async (): Promise<QRProjectOption[]> => {
    const res = await fetch("/api/projects?limit=50&sort=name&order=asc&status=all", {
      cache: "no-store",
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    // SAFETY: the projects route returns the { items } envelope.
    const data = (await res.json()) as QRProjectListResponse;

    return data.items ?? [];
  },
  staleTime: 60_000,
});
